import { render, staticRenderFns } from "./ManageStorage.vue?vue&type=template&id=27b0f31a&scoped=true&"
import script from "./ManageStorage.vue?vue&type=script&lang=js&"
export * from "./ManageStorage.vue?vue&type=script&lang=js&"
import style0 from "./ManageStorage.vue?vue&type=style&index=0&id=27b0f31a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b0f31a",
  null
  
)

export default component.exports